/* eslint-disable import/no-default-export */
import classNames from 'classnames';
import React from 'react';

import styles from './power-up.less';
import Badges from './badges';
import { DescriptionAtomProps } from './types';

export const DescriptionAtom: React.FunctionComponent<DescriptionAtomProps> = ({
  className,
  overview,
  icon,
  name,
  promotional,
  staffPick,
  usage,
  ...props
}) => (
  <div className={classNames(styles.descriptionAtomGrid, className)}>
    <div className={styles.logoNameGrid}>
      <span
        className={styles.icon}
        style={{
          backgroundImage: `url(${icon.url})`,
        }}
      />
      <span className={styles.name} title={name}>
        {name}
      </span>
    </div>
    <Badges promotional={promotional} usage={usage} staffPick={staffPick} />
    <span className={styles.description}>{overview}</span>
    {props.button}
  </div>
);

export const StyledDescriptionAtom: React.FunctionComponent<DescriptionAtomProps> = ({
  className,
  ...props
}) => (
  <DescriptionAtom
    className={classNames(styles.descriptionAtom, className)}
    {...props}
  />
);

export default StyledDescriptionAtom;
